import { motion } from "framer-motion";
import { Container } from "@/components/Container/Container";
import { Section } from "@/components/Section/Section";
import { Reveal } from "@/components/Reveal/Reveal";
import { staggerContainer, staggerItem } from "@/lib/motion";
import { offerings } from "@/spiel/offerings";
import styles from "./Offerings.module.scss";

export const Offerings = () => (
  <Section id="offerings" deep>
    <Container>
      <Reveal>
        <h2 className={styles.heading}>{offerings.heading}</h2>
      </Reveal>

      <Reveal delay={0.05}>
        <article className={styles.primary}>
          <h3 className={styles.primaryTitle}>{offerings.primary.title}</h3>
          <p className={styles.primaryLead}>{offerings.primary.lead}</p>

          <p className={styles.capabilitiesLabel}>
            {offerings.primary.capabilitiesLabel}
          </p>

          <ul className={styles.capabilities}>
            {offerings.primary.capabilities.map((capability) => (
              <li key={capability.label} className={styles.capability}>
                <span className={styles.capabilityLabel}>
                  {capability.label}
                </span>
                <span className={styles.capabilityDetail}>
                  {capability.detail}
                </span>
              </li>
            ))}
          </ul>

          <ul className={styles.primaryBullets}>
            {offerings.primary.bullets.map((bullet) => (
              <li key={bullet.slice(0, 32)} className={styles.primaryItem}>
                {bullet}
              </li>
            ))}
          </ul>
        </article>
      </Reveal>

      {offerings.secondaryLabel ? (
        <Reveal delay={0.1}>
          <p className={styles.secondaryLabel}>{offerings.secondaryLabel}</p>
        </Reveal>
      ) : null}

      <motion.div
        className={styles.grid}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        variants={staggerContainer}
      >
        {offerings.cards.map((card) => (
          <motion.article key={card.title} className={styles.card} variants={staggerItem}>
            <h3 className={styles.title}>{card.title}</h3>
            <p className={styles.description}>{card.oneLiner}</p>
            {card.note ? <p className={styles.note}>{card.note}</p> : null}
          </motion.article>
        ))}
      </motion.div>

      <Reveal delay={0.15}>
        <p className={styles.alaCarte}>{offerings.alaCarte}</p>
      </Reveal>
    </Container>
  </Section>
);
